import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { RequestDeviceWarehouseRefillDto } from "../models/request/request-device-warehouse-refills";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ActionResult } from "../models/core/ActionResult";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { CollisionResolutionWarehouseRefillModel } from "../models/request/collision-resolution-warehouse-refill-model";
import { ConfirmCollisionWarehouseRefill } from "../models/request/confirm-collision-warehouse-refill";
import { RejectCollisionWarehouseRefill } from "../models/request/reject-collision-warehouse-refill";

@Injectable()
export class RequestDeviceWarehouseRefillsService extends DataService<RequestDeviceWarehouseRefillDto, RequestDeviceWarehouseRefillDto> {
	
    constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = 'request-device-warehouse-refills';
	}

	public createRequestDeviceWarehouseRefillByNomenclature(request: RequestDeviceWarehouseRefillDto): Observable<ActionResult> {
		return this.postQuery<ActionResult>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/create-by-nomenclature`, request);
	}
	public deleteRequestDeviceWarehouseRefillByNomenclature(request: RequestDeviceWarehouseRefillDto): Observable<ActionResult> {
		return this.postQuery<ActionResult>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/delete-by-nomenclature`, request);
	}
	public getRequestDeviceWarehouseRefillsWithParts(requestId: number): Observable<ActionDataResult<RequestDeviceWarehouseRefillDto[]>> {
		return this.postQuery<RequestDeviceWarehouseRefillDto[]>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/request-device-warehouse-refills-with-parts`, {requestId: requestId});
	}

	public collisionResolution(model: CollisionResolutionWarehouseRefillModel): Observable<ActionResult> {
		return this.postQuery<any>(`${this.baseUrl()}/collision-resolution`, model);
	}

	public confirmCollision(model: ConfirmCollisionWarehouseRefill): Observable<ActionResult> {
		return this.postQuery<any>(`${this.baseUrl()}/confirm-collision`, model);
	}

	public rejectCollision(model: RejectCollisionWarehouseRefill): Observable<ActionResult> {
		return this.postQuery<any>(`${this.baseUrl()}/reject-collision`, model);
	}
}